import { render } from "./GenericErrorPage.vue?vue&type=template&id=430ad475&scoped=true"
import script from "./GenericErrorPage.vue?vue&type=script&lang=js"
export * from "./GenericErrorPage.vue?vue&type=script&lang=js"

import "./GenericErrorPage.vue?vue&type=style&index=0&id=430ad475&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-430ad475"]])

export default __exports__